import {createContext} from "react";

const ThreadsContext = createContext();

export default ThreadsContext;
